<template>
  <div>
    <data-table
      :items="items"
      v-on:updateData="getShippings"
      :sortOptions="sortOptions"
      :filterOptions="filterOptions"
      :sort="sort"
      :isLoad="isLoad"
      :page="page"
      :rowsPerPage="rowsPerPage"
      :fromRow="fromRow"
      :toRow="toRow"
      :totalRows="totalRows"
      :lastPage="lastPage"
    >
      <template v-slot:headings>
        <div class="col-md-2">Job</div>
        <div class="col-md-3">Device</div>
        <div class="col-md-2">Client</div>
        <div class="col-md-4">Address</div>
        <div class="col-md-1 text-left text-md-right">Action</div>
      </template>

      <template v-slot:rows="slotProps">
        <div class="col-md-2 my-auto">
          <span class="bg-primary font-weight-bold rounded text-white px-1">{{ slotProps.item.job_number }}</span>
          <p class="m-0">
            {{
              moment
                .duration(slotProps.item.tat_seconds, "seconds")
                .format("D [day], H [hour &] m [min]")
            }}
          </p>
          <small v-if="slotProps.item.client_reference">
            {{ slotProps.item.client_reference }}
          </small>
          <small
            v-if="
              slotProps.item.job_reference && !slotProps.item.client_reference
            "
          >
            {{ slotProps.item.job_reference }}
          </small>
        </div>

        <div class="col-md-3 my-auto">
          <p class="m-0">{{ slotProps.item.manufacture.description }}</p>
          <p class="m-0">
            {{ slotProps.item.device_type.code }} -
            <span v-if="slotProps.item.device_model">{{
              slotProps.item.device_model.description
            }}</span>
            <span v-if="!slotProps.item.device_model && slotProps.item.model">{{
              slotProps.item.model
            }}</span>
          </p>
          <p class="m-0" v-if="slotProps.item.imei_in">
            {{ slotProps.item.imei_in }}
          </p>
          <p class="m-0" v-if="!slotProps.item.imei_in">
            {{ slotProps.item.serial_in }}
          </p>
        </div>

        <div class="col-md-2 my-auto">
          <p class="m-0" v-if="slotProps.item.partner_id != null">
            [{{ slotProps.item.partner.name }}]
          </p>
          <p class="m-0" v-if="slotProps.item.client_id != null">
            {{
              slotProps.item.client.name + " " + slotProps.item.client.surname
            }}
          </p>
          <p class="m-0" v-if="slotProps.item.client_id != null">
            {{ slotProps.item.client.contact_number }}
          </p>
          <p class="m-0" v-if="slotProps.item.client_id == null">
            {{ slotProps.item.partner.contact_number }}
          </p>
        </div>

        <div class="col-md-4 my-auto">
          <span v-if="slotProps.item.client_id != null">
            <p class="m-0">{{ slotProps.item.client.address }}</p>
            <p class="m-0">
              {{ slotProps.item.client.city }} -
              {{ slotProps.item.client.postal_code }}
            </p>
            <p class="m-0" v-if="slotProps.item.client.province && slotProps.item.client.province.province">{{ slotProps.item.client.province.province }}</p>
          </span>
        </div>

        <div class="col-md-1 my-auto text-left text-md-right pt-3 pt-md-0">
          <router-link
            v-b-tooltip.hover
            title="Device Received"
            :to="{
              name: 'shipping-inbound-received-create',
              params: { id: slotProps.item.id },
            }"
            class="text-info table-action-icon"
          >
            <i class="lni lni-arrow-right-circle"></i>
          </router-link>
        </div>
      </template>
    </data-table>

    <b-modal
      :hide-footer="true"
      :title="$route.meta.title"
      size="lg"
      v-model="sidebarToggle"
      :no-close-on-route-change="true"
      @hidden="$router.push({ name: 'shipping-inbound' })"
      :lazy="true"
    >
      <router-view @receivedCreated="receivedCreated()"></router-view>
    </b-modal>
  </div>
</template>

<script>
import shippingRepo from "@/api/repos/shippingRepo";
import dataTable from "@/components/common/DataTable";

export default {
  components: {
    dataTable: dataTable,
  },

  data() {
    return {
      sidebarToggle: false,
      isLoad: false,
      sort: { column: "id", label: "Job Desc", order: "desc" },
      sortOptions: [
        { column: "id", label: "Job Asc", order: "asc" },
        { column: "id", label: "Job Desc", order: "desc" },
      ],
      filterOptions: [],
      page: 1,
      rowsPerPage: localStorage.getItem("rowsPerPage")
        ? localStorage.getItem("rowsPerPage")
        : 10,
      fromRow: 0,
      toRow: 0,
      totalRows: 0,
      lastPage: 0,
      items: [],
    };
  },
  mounted() {
    this.getShippings({
      sort: this.sort,
      filters: null,
      page: this.page,
      rowsPerPage: localStorage.getItem('rowsPerPage')?localStorage.getItem('rowsPerPage'):10,
      search: "",
    });
  },
  methods: {
    async getShippings(e) {
      this.isLoad = true;
      try {
        let { data } = await shippingRepo.inbound(
          e.page,
          e.rowsPerPage,
          e.sort.column,
          e.sort.order,
          e.search,
          e.filters != null ? e.filters : null
        );

        this.items = data.jobs.data;
        this.totalRows = data.jobs.total;
        this.page = data.jobs.current_page;
        this.fromRow = data.jobs.from;
        this.toRow = data.jobs.to;
        this.lastPage = data.jobs.last_page;
      } catch (error) {
        console.log(error);
      } finally {
        this.isLoad = false;
      }
    },

    receivedCreated() {
      this.$bvToast.toast("Received", {
        title: "Success",
        autoHideDelay: 3000,
        variant: "success",
      });
      this.sort = {
        column: "id",
        label: "Job",
        order: "desc",
      };
      this.page = 1;
      this.sidebarToggle = false;
      this.getShippings({
        sort: this.sort,
        filters: null,
        page: this.page,
        rowsPerPage: localStorage.getItem('rowsPerPage')?localStorage.getItem('rowsPerPage'):10,
        search: "",
      });
    },
  },

  watch: {
    $route: {
      immediate: true,
      handler: function (newVal) {
        this.sidebarToggle = newVal.meta && newVal.meta.sidebarToggle;
      },
    },
  },
};
</script>
